import { useCallback, useMemo } from 'react';
import { Badge, Card, HStack, ListSection, MultiButton, TestProps, Text } from '@direct-frontend/components';
import { i18n } from './ShowSelectedOnlySwitcher.i18n';

type ShowSelectedSwitcherProps = Required<TestProps> & {
    selectedCount: number;
    value: string;
    onChange: (value: boolean) => void;
    size?: 'xs' | 's' | 'm';
    hideAmount?: boolean;
};

export function ShowSelectedOnlySwitcher({
    'data-testid': dataTestId,
    selectedCount,
    hideAmount = false,
    value,
    onChange,
    size = 'xs',
}: ShowSelectedSwitcherProps) {
    const badgeColor = selectedCount === 0 ? 'message' : 'info';
    const badgeSize = size === 'm' ? '24' : '16';
    const textSize = size === 'xs' ? 's' : 'm';

    const options = useMemo(
        () => [
            { value: 'false', content: i18n('Все') },
            {
                value: 'true',
                content: (
                    <HStack alignItems="center" gap="8">
                        <Text size={textSize}>{i18n('Выбранные')}</Text>
                        <Badge color={badgeColor} size={badgeSize} children={hideAmount ? '' : String(selectedCount)} />
                    </HStack>
                ),
            },
        ],
        [badgeColor, badgeSize, hideAmount, selectedCount, textSize]
    );

    const handleChange = useCallback(
        (value: string) => {
            onChange(value === 'true');
        },
        [onChange]
    );

    return (
        <ListSection>
            <Card padding="14" paddingCorrection="top-bottom">
                <MultiButton
                    data-testid={dataTestId}
                    options={options}
                    onChange={handleChange}
                    size={size}
                    width="max"
                    withEqualButtons
                    value={value}
                />
            </Card>
        </ListSection>
    );
}
